// extracted by mini-css-extract-plugin
module.exports = {"marker":"vnC4j_","pin":"_22Oicv","spinner":"dD_l8f","spin":"RqjZDH","label":"_2jSlWI","person":"_1gafB6"};